import { isEnsured } from '@/utils/dictionary'

export const IsEnsured = (value: string | number) => {
  const result = isEnsured.find(item => item.value === value + '')
  return result ? result.label : ''
}
